import * as types from "./types";

/**
 * `overview` / `quickActions` hold the raw `data` object from each endpoint
 * (PROLINE-3755) as-is (snake_case) — the composing container reads the API
 * field names directly and builds the display props each widget needs.
 */
const initialState = {
  overview: null,
  overviewLoading: false,
  quickActions: null,
  quickActionsLoading: false,
  /** Raw `data` array of companies_overview (PROLINE-3826), top 3 by Saudi applicants. */
  topCompanies: [],
  topCompaniesLoading: false,
  /** Raw `data` array of events_overview (PROLINE-3826), top 3 of the last 30 days. */
  topEvents: [],
  topEventsLoading: false,
  /** Raw `data` array of companies_overview?has_evaluated_events=true (PROLINE-3826). */
  companySatisfaction: [],
  companySatisfactionLoading: false,
  /** Raw `data` array of companies_overview ordered by junior_applicants_percentage (PROLINE-3853). */
  applicantEngagement: [],
  applicantEngagementLoading: false,
  /** Raw `data` array of activity_logs?actor_type=Admin (PROLINE-3943), newest 10. */
  recentActivity: [],
  recentActivityLoading: false,
};

const adminDashboard = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ADMIN_DASHBOARD_OVERVIEW_REQUEST:
      return { ...state, overviewLoading: true };
    case types.GET_ADMIN_DASHBOARD_OVERVIEW_RESPONSE:
      return { ...state, overview: action.payload, overviewLoading: false };
    case types.GET_ADMIN_DASHBOARD_QUICK_ACTIONS_REQUEST:
      return { ...state, quickActionsLoading: true };
    case types.GET_ADMIN_DASHBOARD_QUICK_ACTIONS_RESPONSE:
      return {
        ...state,
        quickActions: action.payload,
        quickActionsLoading: false,
      };
    case types.GET_ADMIN_DASHBOARD_TOP_COMPANIES_REQUEST:
      return { ...state, topCompaniesLoading: true };
    case types.GET_ADMIN_DASHBOARD_TOP_COMPANIES_RESPONSE:
      return {
        ...state,
        topCompanies: action.payload,
        topCompaniesLoading: false,
      };
    case types.GET_ADMIN_DASHBOARD_TOP_EVENTS_REQUEST:
      return { ...state, topEventsLoading: true };
    case types.GET_ADMIN_DASHBOARD_TOP_EVENTS_RESPONSE:
      return { ...state, topEvents: action.payload, topEventsLoading: false };
    // A failed load only clears the loading flag — the last data stays on screen.
    case types.GET_ADMIN_DASHBOARD_OVERVIEW_FAILURE:
      return { ...state, overviewLoading: false };
    case types.GET_ADMIN_DASHBOARD_QUICK_ACTIONS_FAILURE:
      return { ...state, quickActionsLoading: false };
    case types.GET_ADMIN_DASHBOARD_TOP_COMPANIES_FAILURE:
      return { ...state, topCompaniesLoading: false };
    case types.GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_REQUEST:
      return { ...state, companySatisfactionLoading: true };
    case types.GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_RESPONSE:
      return {
        ...state,
        companySatisfaction: action.payload,
        companySatisfactionLoading: false,
      };
    case types.GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_FAILURE:
      return { ...state, companySatisfactionLoading: false };
    case types.GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_REQUEST:
      return { ...state, applicantEngagementLoading: true };
    case types.GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_RESPONSE:
      return {
        ...state,
        applicantEngagement: action.payload,
        applicantEngagementLoading: false,
      };
    case types.GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_FAILURE:
      return { ...state, applicantEngagementLoading: false };
    case types.GET_ADMIN_DASHBOARD_TOP_EVENTS_FAILURE:
      return { ...state, topEventsLoading: false };
    case types.GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_REQUEST:
      return { ...state, recentActivityLoading: true };
    case types.GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_RESPONSE:
      return {
        ...state,
        recentActivity: action.payload,
        recentActivityLoading: false,
      };
    case types.GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_FAILURE:
      return { ...state, recentActivityLoading: false };
    default:
      return state;
  }
};

export default adminDashboard;
